import React from 'react';
import { CardDeclineRequestProps } from './types';
import {
    Header,
    InfoGroup,
    RequestInfo,
    StyledTooltip,
    TagsWrapper,
    Title,
    Wrapper,
} from './card-decline-request.styles';
import { Button, Tag } from '@vtbhome/juicyfront';
import { Typography } from '../typography/typography';
import { StatusInfoOutline } from '@vtbhome/juicyfront/indexIcon';
import { useHistory } from 'react-router-dom';
import { ROUTE_ADMIN_PRODUCT_BASE } from '@shared/config/routes/routes';
import { datePeriod } from '@shared/lib/utils/date/date';
import { EntityRelatedUser } from '../entity-related-user/entity-related-user';
import { productPrice } from '@shared/lib/utils/product-price/product-price';

export const CardDeclineRequest: React.FC<CardDeclineRequestProps> = ({ request, user, product }) => {
    const history = useHistory();

    return (
        <Wrapper>
            <Header>
                <RequestInfo>
                    <Typography size='body2_short' color='neutral_50'>
                        {datePeriod(product.startAt || '', product.endAt || '')}
                        {product.place && ` · ${product.place}`}
                    </Typography>
                    <Title size='subtitle3'>{product.name}</Title>

                    <TagsWrapper>
                        <Tag variant='grey'>
                            <Typography size='body2_short'>{product.type.name}</Typography>
                        </Tag>
                    </TagsWrapper>
                </RequestInfo>
                <StyledTooltip position='bottom'>
                    <Button
                        size='s'
                        buttonType='secondary'
                        startAdornment={<StatusInfoOutline size='xxs' />}
                        onClick={() => history.push(`${ROUTE_ADMIN_PRODUCT_BASE}/${product.id}`)}
                    />
                    <Typography as='p' size='body2_short' align='center'>{`Открыть карточку\nпродукта`}</Typography>
                </StyledTooltip>
            </Header>
            <InfoGroup>
                <Typography size='body2_long' color='neutral_50'>
                    Инициатор
                </Typography>
                <EntityRelatedUser user={user} nameType='short' />
            </InfoGroup>
            <InfoGroup>
                <Typography size='body2_long' color='neutral_50'>
                    Количество
                </Typography>
                <Typography size='body2_long'>{request.quantity}</Typography>
            </InfoGroup>
            <InfoGroup>
                <Typography size='body2_long' color='neutral_50'>
                    Стоимость
                </Typography>
                <Typography size='body2_long'>
                    {productPrice({
                        price: (request.quantity * parseInt(product.price)).toFixed(2),
                        withoutPrice: product.isPriceUndefined,
                    })}
                </Typography>
            </InfoGroup>
        </Wrapper>
    );
};
